// Swiper core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Scrollbar } from 'swiper/modules';
// Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import 'swiper/css/grid';
export var TeamMembersController = {
    init: function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                _this.initTeamMembersListAndPagination();
                resolve();
            }
            catch (error) {
                reject(error);
            }
        });
    },
    initTeamMembersListAndPagination: function () {
        var team_members_block = document.querySelector('.team-members__block');
        if (team_members_block) {
            var grid_1 = document.getElementById('team-members__container-grid');
            var filterBar_1 = document.querySelector('.team-members__categories-filters');
            var globalDesc_1 = document.getElementById('team-members__description');
            if (!grid_1 || !filterBar_1 || !globalDesc_1)
                return;
            var team_members__container_grid = document.querySelector('.team-members__container-grid');
            var swiper_1 = null;
            if (team_members__container_grid) {
                swiper_1 = new Swiper(team_members__container_grid, {
                    modules: [Navigation, Scrollbar],
                    spaceBetween: 30,
                    slidesPerView: 4,
                    scrollbar: {
                        el: '.swiper-scrollbar',
                        draggable: true,
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    breakpoints: {
                        320: {
                            slidesPerView: 1,
                        },
                        768: {
                            slidesPerView: 2,
                        },
                        1024: {
                            slidesPerView: 4,
                        },
                    },
                });
            }
            // Helpers
            var allDescPanels_1 = function () {
                return globalDesc_1.querySelectorAll('.team-members__description-panel');
            };
            var closeAll_1 = function () {
                // Hide container and all panels
                allDescPanels_1().forEach(function (p) { return (p.hidden = true); });
                globalDesc_1.hidden = true;
                // Reset buttons
                grid_1.querySelectorAll('.team-member__card-desc[aria-expanded="true"]').forEach(function (btn) {
                    btn.setAttribute('aria-expanded', 'false');
                    btn.setAttribute('aria-label', 'Show description');
                });
                // Remove [data-active] from any active card
                grid_1.querySelectorAll('.team-member__card[data-active]').forEach(function (card) {
                    card.removeAttribute('data-active');
                });
            };
            // Click handler (event delegation)
            grid_1.addEventListener('click', function (ev) {
                var target = ev.target;
                var btn = target === null || target === void 0 ? void 0 : target.closest('.team-member__card-desc');
                var clickedCard = target === null || target === void 0 ? void 0 : target.closest('.team-member__card');
                if (!btn)
                    return;
                var targetId = btn.getAttribute('data-target');
                var panel = targetId ? document.getElementById(targetId) : null;
                if (!panel || !clickedCard)
                    return;
                var isOpen = btn.getAttribute('aria-expanded') === 'true';
                if (!isOpen) {
                    // Close others and show the selected panel
                    closeAll_1();
                    globalDesc_1.hidden = false;
                    panel.hidden = false;
                    btn.setAttribute('aria-expanded', 'true');
                    btn.setAttribute('aria-label', 'Hide description');
                    // Mark the clicked card as active
                    clickedCard.setAttribute('data-active', 'true');
                }
                else {
                    // Clicking the already-open card closes everything
                    closeAll_1();
                }
            });
            // Category filter
            var setActiveFilter_1 = function (targetBtn) {
                filterBar_1.querySelectorAll('button.team-members__categories-filters').forEach(function (b) {
                    var isActive = b === targetBtn;
                    b.classList.toggle('is-active', isActive);
                    b.setAttribute('aria-selected', isActive ? 'true' : 'false');
                });
            };
            var applyFilter_1 = function (slug) {
                var effective = slug !== null && slug !== void 0 ? slug : 'all';
                var cards = grid_1.querySelectorAll('.team-member__card');
                var showAll = effective === 'all';
                cards.forEach(function (card) {
                    var terms = (card.getAttribute('data-terms') || '').split(/\s+/).filter(Boolean);
                    var match = showAll ? true : terms.includes(effective);
                    card.style.display = match ? '' : 'none';
                });
                // When changing the filter, close the global description
                closeAll_1();
            };
            filterBar_1.addEventListener('click', function (ev) {
                var target = ev.target;
                var btn = (target === null || target === void 0 ? void 0 : target.closest('button.team-members__categories-filters')) || null;
                if (!btn)
                    return;
                var slug = btn.getAttribute('data-term');
                setActiveFilter_1(btn);
                applyFilter_1(slug);
                // Update Swiper an back to slide 0 to avoid display issue when filtering
                swiper_1 === null || swiper_1 === void 0 ? void 0 : swiper_1.update();
                swiper_1 === null || swiper_1 === void 0 ? void 0 : swiper_1.slideTo(0);
            });
            // Start with "All"
            applyFilter_1('all');
        }
    },
};
